"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _getGlobal = _interopRequireDefault(require("../../utils/getGlobal")); // Expects we've set up Amazon's apstag JS before this.


var _default = function _default() {
  var global = (0, _getGlobal.default)();
  return global.apstag;
};

exports.default = _default;